export default __webpack_public_path__ + "static/13-c162fe2049e5c9ef5dd9589b4ad6584d.png";